import { defineComponent } from 'vue';
import { useRegisterTestStore } from '@/store/RegisterTestStore';
import FloatingCard from '@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue';
import CounterModal from '@/components/Shared/Modals/CounterModal/CounterModal.vue';
import AwaitModal from '@/components/Shared/Modals/AwaitModal/AwaitModal.vue';
import ShowDevicePositionModal from '@/components/Modals/Hiv/ShowDevicePositionModal/ShowDevicePositionModal.vue';
import { mapWritableState } from 'pinia';
import DropSample from '@/assets/covid/3-drop.gif';
import ThemesHelper from '@/helpers/ThemesHelper';
import AlertBox from '@/components/AlertBox/AlertBox.vue';

export default defineComponent({
  props: {
    active: {
      type: Boolean,
    },
  },
  components: {
    FloatingCard,
    CounterModal,
    AwaitModal,
    AlertBox,
    ShowDevicePositionModal,
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ['canJumpNext']),
  },
  data() {
    return {
      DropSamplePath: DropSample,
      imagePath: '',
      StepContent: ThemesHelper.getThemeParams('testStepThreeContents'),
    };
  },
  methods: {
    isValidStep(): boolean {
      // no validation
      return true;
    },
    toggleModal(status: boolean) {
      const el: any = this.$refs['base-modal'];
      el.toggleBaseModal(status);
    },
    setAnimationType(animationName: string) {
      setTimeout(() => {
        const baseModal: any = this.$refs['base-modal'];
        switch (animationName) {
          case 'setNextDismissAnimation':
            baseModal.setNextDismissAnimation();
            break;
          case 'setNextShowAnimation':
            baseModal.setNextShowAnimation();
            break;
          case 'setPreviousDismissAnimation':
            baseModal.setPreviousDismissAnimation();
            break;
          case 'setPreviousShowAnimation':
            baseModal.setPreviousShowAnimation();
            break;
        }
      }, 1);
    },
  },
  mounted() {
    const array: any = JSON.parse(JSON.stringify(this.StepContent));
    this.imagePath = array.image
      ? require(`@/assets/themes/${array.image}`)
      : '';
  },
});
